import React from 'react'

interface MandatoryTextProps extends React.HtmlHTMLAttributes<HTMLLabelElement>{
}
function MandatoryText({...props}:MandatoryTextProps) {
  return (
    <div className='polymer-mandatory-text'>
      <p className='m-0' style={{color: "#C3141E"}}>*</p><label className='m-0' style={{...props.style}}>Requires mandatory information</label>
    </div>
  )
}

export default MandatoryText